<template>
    <b-modal id="reassignJobToStaffModal" centered modal-class="modal-garden-help modal-confirm-message"
        title="Reassign Job" title-class="modal-title-garden-help">
        <div class="d-block ">
            <input id="job_id" name="job_id" type="hidden" v-model="job_id" />
            <input id="client" name="client" type="hidden" v-model="client_name" />
            

            <b-row class="" v-if="!staff && assigned_operator_obj">
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help my-0 pb-0" label="Assigned contractor:" label-for="name" 
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help">
                            {{ assigned_operator_obj.name }}
                        </span>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="">
                <b-col xl="8" lg=10 md="11">
                    <b-form-group class="form-group-garden-help  mb-0 pb-0" label="Staff" label-for="staff"
                        label-class="form-label-garden-help">
                        <p class="error_validation_message_p_gardenhelp" v-if="invalid_staff">
                            Please select staff
                        </p>
                        <v-select :options="staff_list" v-model="staff" name="staff" title="staff"
                            placeholder="Select staff" label="name" :reduce="(item) => item.id" :clearable="false"
                            :multiple="false" required>
                        </v-select>
                    </b-form-group>
                </b-col></b-row>
            <b-row class="" v-if="staff">
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help my-0 pb-0" label="Name:" label-for="name" :name="name"
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help">
                            {{ name }}
                        </span>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help  my-0 pb-0" label="Email:" label-for="email" :email="email"
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help">
                            {{ email }}
                        </span>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group class="form-group-garden-help  my-0 pb-0" label="Phone" label-for="phone" :phone="phone"
                        label-class="form-label-garden-help d-inline" label-cols-sm="3" label-cols-lg="2"
                        content-cols-sm="9" content-cols-lg="9">
                        <span class="form-control form-control-garden-help">
                            {{ phone }}
                        </span>
                    </b-form-group>
                </b-col></b-row>
        </div>

        <template class="justify-content-center mt-5" #modal-footer>
            <b-row class="justify-content-center w-100 m-0">
                <b-col xl="4" lg="5" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100"
                        v-if="!is_loading" @click="clickSave">
                        Assign
                    </b-button>
                    <b-button type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help  mb-1 w-100" v-else>
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
                <b-col xl="4" lg="5" md="6" class="text-center">
                    <b-button type="button" variant="garden-help-danger-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="closeModalCancel">
                        Cancel
                    </b-button>
                </b-col>


            </b-row>
        </template>
    </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
    name: "ReassignJobStaff",
    components: {},
    props: ["client_name", "job_id", "assigned_operator_obj"],
    data() {
        return {
            is_loading: false,
            staff: null,
            staff_list: [],
            invalid_staff: false,
            //selected staff data
            name: null, email: null, phone: null
        };
    },
    watch: {
        staff(newval, oldval) {
            console.log("staff", newval)
            let selected_staff = this.staff_list.find(element => element.id == newval)
            console.log(selected_staff)
            this.name = selected_staff.name
            this.email = selected_staff.email
            this.phone = selected_staff.phone
        }
    },
    mounted() {
        this.getStaffsList()
    },

    methods: {
        getStaffsList() {
            console.log("in get staff list")
            axios
                .post("/operator/contractor/list-staff", {}, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.staff_list = response.data.data;
                });

        },
        clickSave() {
            console.log("in confirm assign job ", this.client_name, this.job_id, this.staff);

            if (this.staff == null || this.staff == '') {
                this.invalid_staff = true
            } else {
                this.invalid_staff = false
                this.is_loading = true;

                // this.$bvModal.hide("rescheduleJobModal");
                let requestData = {
                    client: this.client_name,
                    "status": "accepted",
                    "operator_id": this.staff,
                }
                axios
                    .post(
                        "/jobs/job-action/" + this.job_id,
                        requestData,
                        {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                client: this.client_name,
                                Authorization:
                                    "Bearer " +
                                    JSON.parse(window.localStorage.getItem("user")).access_token,
                            },
                        }
                    )
                    .then((response) => {
                        console.log(response);
                        this.is_loading = false;
                        this.$fire({
                            text: "Job is reassigned successfully.",
                            type: "success",
                            customClass: {
                                container: "swal-alert-garden-help",
                                confirmButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                                cancelButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                            },

                        }).then((r) => {
                            this.$bvModal.hide("reassignJobToStaffModal");
                            this.$parent.getJobDetails()
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        this.is_loading = false;

                        this.$fire({
                            // title: "Title",
                            text: error.response.data.error,
                            type: "error",
                            customClass: {
                                container: "swal-alert-garden-help",
                                confirmButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                                cancelButton:
                                    "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                            },
                            // timer: 5000,
                        }).then((r) => {
                        });

                    });

            }




            return;

        },
        closeModalCancel() {
            this.$bvModal.hide("rescheduleJobModal");
        },
    },
};
</script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/modal_actions/ReassignJobStaff.vue